import type { NavProps } from "@/components/nav";

export const navData: NavProps["data"] = [
	{
		name: "Tenant management",
		items: [
			// management
			{
				title: "Tenant List",
				path: "/tenant",
			},
		],
	},
	{
		name: "Version management",
		items: [
			// management
			{
				title: "Console Version",
				path: "/console-version",
			},
			{
				title: "Bot Version",
				path: "/bot-version",
			},
			{ title: "Portfolio Version", path: "/portfolio-version" },
		],
	},
	{
		name: "Instance management",
		items: [
			// management
			{
				title: "Console Instance",
				path: "/console-instance",
			},
			{
				title: "Bot Instance",
				path: "/bot-instance",
			},
			{ title: "Portfolio Instance", path: "/portfolio-instance" },
		],
	},
	{
		name: "Parameter management",
		items: [
			// management
			{
				title: "Parameter Schema",
				path: "/parameter-schema",
			},
			{ title: "Portfolio Parameter", path: "/portfolio-parameter-schema" },
		],
	},
	{
		name: "Support Case management",
		items: [
			// management
			{
				title: "Support Case Info",
				path: "/support-case",
			},
			{ title: "Portfolio Support Case", path: "/portfolio-support-case" },
		],
	},
	{
		name: "Bot state management",
		items: [
			// management
			{
				title: "Bot state",
				path: "/bot-state",
			},
		],
	},
	{
		name: "Bot Volume Overview",
		items: [
			// management
			{
				title: "Bot Volume",
				path: "/bot-volume",
			},
		],
	},
];
